import axios from "axios";
import { useRef } from "react";

import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import './MyStyles.css';

import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import AlarmIcon from "@mui/icons-material/Alarm";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from '../context/AuthContext';

import { baseUrl, baseimgUrl, userLocation, ipAddress, userName } from './Univ.js';

const formatDateTime = (dateTimeString) => {
  return new Date(dateTimeString).toLocaleString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

function Header(props) {

const audioRef = useRef(null);
  const [searchString, setsearchString] = useState({ search: '' });
  const { logoutUser } = useAuth();
const [alerts,setAlerts] = useState([]);
const [alertSound,setAlertSound] = useState(false);
  const checkUser = localStorage.getItem('user_login');
  const checkPat = localStorage.getItem('pat_login');
  const pat_id = localStorage.getItem('pat_id');
  const userGroup = localStorage.getItem('userGroup');

  const [tasks, setTasks] = useState([]);
  const [unreadTasks, setUnreadTasks] = useState([]);

  const [reminderTasks, setReminderTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (checkUser === 'true') {
      fetchTasks();
    }
  }, [checkUser]);


const prevAlertCount = useRef(0);

useEffect(() => {

  if (checkUser !== "true") return;

  const interval = setInterval(() => {

    axios.get(`${baseUrl}system-alerts/`)
      .then(res => {

        if (res.data.length > prevAlertCount.current) {
          playAlertSound();
        }

        prevAlertCount.current = res.data.length;
        setAlerts(res.data);

      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          console.log("User not authenticated, stopping alerts polling");
        } else {
          console.log(err);
        }
      });

  }, 5000);

  return () => clearInterval(interval);

}, [checkUser]);

const playAlertSound = () => {

  if (!audioRef.current) {
    audioRef.current = new Audio("/alert.mp3");
    audioRef.current.loop = true;
  }

  audioRef.current.play().catch(err => console.log(err));
};


  const countReminders = reminderTasks.length;
  const reminderBadgeColor = countReminders > 0 ? "warning" : "default";
  const reminderIconColor = countReminders > 0 ? "error" : "action";

  const fetchTasks = async () => {
    try {
      const response = await axios.get(baseUrl + "get-todo/");
      setTasks(response.data);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    }
  };

  useEffect(() => {
    setUnreadTasks(tasks.filter(row => row.status === 1 && row.addedby === userName));
  }, [tasks]);

  const countUnreadTasks = unreadTasks.length;

const handleLogout = () => {
  setAlerts([]);
  logoutUser();
  window.location.href = '/user-login/';
};
  const linkMap = {
    Admin: { home: '/admin-menu/', menu: '/' },
    Pharmacy: { home: '/pharm-menu/', menu: '/pharm-menu' },
    PharmacyStore: { home: '/pharm-store/', menu: '/pharm-menu' },
  };

  const links = linkMap[userGroup] || {};

  const handleChange = (event) => {
    setsearchString({
      ...searchString,
      [event.target.name]: event.target.value,
    });
  };


  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">
      <div className="container">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
          {checkUser === 'true' && (
            <>
              <Link className="navbar-brand" to={links.menu}>MGM DrHIS Pharma</Link>


              <ul className="navbar-nav ms-auto flex-row align-items-center gap-3">
                <li className="nav-item">
                  <Link className="navbar-brand" to={links.home}>
                    <FontAwesomeIcon icon="fa-solid fa-house-user" size="1x" color="#ffc107" />
                  </Link>
                </li>

                <li className="nav-item">
                  <Badge color={countUnreadTasks > 0 ? "warning" : "default"} badgeContent={countUnreadTasks}>
                    <a href="/todolist">
                      <MailIcon color={countUnreadTasks > 0 ? "error" : "action"} />
                    </a>
                  </Badge>
                </li>
<li className="nav-item">

<Badge
  color={alerts.length > 0 ? "error" : "default"}
  badgeContent={alerts.length}
>

<a href="/alerts" >
  <NotificationsActiveIcon
    color={alerts.length > 0 ? "error" : "action"}
  />
</a>

</Badge>

</li>

                {/* USER DROPDOWN */}
<li className="nav-item dropdown">
  <a
    className="nav-link dropdown-toggle"
    href="#"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    {userName}
  </a>

  <ul className="dropdown-menu dropdown-menu-end">
    <li className="dropdown-item">Welcome: {userName}</li>

    <li>
      <Link className="dropdown-item" to="/admin-menu">
        Menu
      </Link>
    </li>

    <li>
      <Link className="dropdown-item" to="/change-password">
        Change Password
      </Link>
    </li>

    <li>
      <button className="dropdown-item" onClick={handleLogout}>
        Logout
      </button>
    </li>
  </ul>
</li>

              </ul>
            </>
          )}


          {!checkUser && !checkPat && (
            <h3 className="text-white text-center">MGM DrHIS Pharma</h3>
          )}
        </div>
      </div>
    </nav>
  );
}

export { formatDateTime };
export default Header;
